module.exports = __webpack_public_path__ + "static/media/discos.54babcb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discos.svg
// module id = 304
// module chunks = 25